const $ = window.jQuery;
const $window = window.$window || $(window);


const Greeting = {


  init () {
    var $greeting = $('#greeting');
    if (!$greeting.length)
        return;
    console.log(sessionStorage.getItem('greeting'));
    if(sessionStorage.getItem('greeting') != 'true'){
      $('body #greeting').show();
      sessionStorage.setItem('greeting', 'true')
      setTimeout(function(){
        $('body #greeting').hide();
      }, 3000);
    }

  }
};

export default Greeting;